import Vue from "vue";
import {
    GET_PAYMENTS,
    GET_PAYMENT_DETAIL,
} from "./types";

export const doGetPayments = (context, params) => Vue.$rest.executeRequest(context, GET_PAYMENTS, 'transactions' + params, null);

export const doGetPaymentDetail = (context, id) => Vue.$rest.executeRequest(context, GET_PAYMENT_DETAIL, `transactions/${id}`);
